import PhoneSliderSection from "./sections/phoneSliderSection";
export default function usersSliders() {
    const sections = document.querySelectorAll('[data-phone-slider]')
    sections.forEach(section => new PhoneSliderSection(section));
}